<template>
    <div class="animated fadeIn">
        <b-card header-tag="header">
            <div slot="header">
                <i class="icon-screen-smartphone"></i> Maquinetas
                <b-link :to="actionUri" class="btn mr-2 btn-sm btn-primary float-right">
                <i class="fa fa-angle-left"></i>
                  Voltar
                </b-link>
            </div>
            <b-card-body>
                <form @submit.prevent="validate" class="needs-validation" novalidate>
                    <div class="form-row">
                        <div class="col-sm-6">
                            <base-input label="Nome" required type="text" placeholder="Digite seu nome" v-model="model.name" v-validate="modelValidations.name" data-vv-name="name" data-vv-as="nome" maxlength="255" :error="getError('name')"/>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label for="exampleFormControlSelect1">Adquirente</label>
                                <select :class="{'custom-select': true, 'is-invalid': errors.has('acquirerId')}" v-validate="modelValidations.acquirerId" v-model="model.acquirerId" data-vv-name="acquirerId" data-vv-as="adquirente">
                                    <option v-for="(s, index) in acquirerList" :key="index" :value="s.id">
                                        {{s.name}}
                                    </option>
                                </select>
                                <div v-show="errors.has('acquirerId')" class="invalid-feedback">
                                    {{ errors.first('acquirerId') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" v-model="model.isActive" id="customSwitch1">
                                    <label class="custom-control-label" for="customSwitch1">Ativo</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary">Salvar</button>
                </form>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import helperService from '../../../services/Helper/helperService'
import domainService from '../../../services/Devices/deviceModelService'
import acquirerService from '../../../services/Acquirer/acquirerService'
import editPage from '../../../mixins/editPage'
export default {
    props: {
        id: String
    },
    mixins:[editPage],
    data() {
        return {
            actionUri: '/platform/deviceModel',
            acquirerList: [],
            model: {
                name: '',
                id: 0,
                acquirerId: null,
                isActive: false
            },
            modelValidations: {
                name: {
                    required: true,
                    max: 255
                },
                acquirerId: {
                    required: true
                }
            }
        }
    },
    computed: {
        action() {
            return this.$route.name
        }
    },
    created(){
        this.fetchData()
    },
    methods: {
        fetchData() {
            const self = this
            this.showLoading()
            acquirerService.getList().then((response) =>{
                self.acquirerList = response.data
                self.acquirerList.unshift({ id: null, name: 'Selecione um adquirente'})
                self.hideLoading()
            }, () => {
                self.hideLoading()
            })

            if(this.action == 'edit_deviceModel') {
                self.showLoading()
                domainService.find(this.id).then((response) =>{
                    self.model = response.data
                    self.hideLoading()
                }, () => {
                    self.hideLoading()
                })
            }
        },
        validate() {
            this.showLoading()
            const self = this
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    if(this.action == 'new_deviceModel') {
                        domainService.create(self.model).then(() => {
                            self.hideLoading()
                            self.$router.push({ path:self.actionUri})
                        })
                    }
                    else {
                        self.model.id = self.id
                        domainService.update(self.model).then(() => {
                            self.hideLoading()
                            self.$router.push({ path: self.actionUri})
                        })
                    }
                } 
                else 
                {
                    self.hideLoading()
                }
            })
        }
    }
}
</script>
